import React from 'react';

const UnauthorizedPage = () => {
    return (
        <div
            className={`w-screen h-screen bg-[#0A0813E3] flex items-center justify-center absolute transition-opacity duration-200 
                     "opacity-100 scale-100"
                }`}
        >
            <div
                className={`bg-white absolute rounded-[24px] shadow-md p-8 w-[311px] h-[353px] xl:h-[260px] xl:w-[403px] flex flex-col gap-4 items-center justify-center text-center xl:p-10 xl:gap-4 transition-transform duration-400`}
            >
                <img src="/images/error.png" className="w-[36px]" alt="" />
                <h2 className="font-bold text-[20px] leading-[122%] tracking-[0%] text-center   xl:text-[20px] 2xl:text-[22px] xxl:text-2xl xl:leading-none text-[#5D0E23] xl:tracking-normal">
                    Unauthorized
                </h2>
                <p className="font-medium text-[12px] w-[250px] leading-none tracking-[0%] text-center   xl:text-[12px] 2xl:text-[14px] xxl:text-base xl:leading-none xl:tracking-normal text-[#636D80]">
                    You do not have permission to access this page.Please contact your administrator if you believe this is an error.
                </p>
                {/* <button
                    type="button"
                    className="mt-4 bg-[#5D0E23] hover:bg-[#55051A] font-semibold xl:text-[12px] 2xl:text-[13px] xxl:text-[14px] leading-none tracking-[-0.04em] text-center  cursor-pointer translate-all duration-400 text-white py-3 px-9  xl:py-3 2xl:py-4 xxl:py-5 xl:px-10 2xl:px-11 xxl:px-12 rounded-lg"
                >
                    Close
                </button> */}
            </div>
        </div>
    );
};

export default UnauthorizedPage;